import { ComponentWithApplyButtonInterface } from 'domains/job-detail/application/interfaces';
import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import { useState } from 'react';

import AnonymousWrapper from '@pflegia/ui/shared/wrapper/AnonymousWrapper';

import FullPageImage from '@components/full-page-image/FullPageImage';

import { FUNNEL } from '@shared/application/constants';
import OffersDialogueButton from '@shared/components/dialogue';
import { useRouterHelper } from '@shared/hooks/use-router-helper';

import Section, { SectionTitle } from '../section/Section.component';

interface OurTeamProps extends ComponentWithApplyButtonInterface {
  image: string;
  formalLanguage?: boolean;
  anonymous: boolean;
  employerName?: string;
  slug: string;
}

export const OurTeam = ({
  image,
  formalLanguage = false,
  anonymous,
  status,
  title,
  jobPositionId,
  type,
  slug,
  openDialog,
  employerName,
}: OurTeamProps): React.JSX.Element => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'ourTeam' });
  const { isExternalJob } = useRouterHelper();
  const [preview, setPreview] = useState<boolean>(false);
  return (
    <Section>
      <SectionTitle t={t} titleKey='title' />
      <AnonymousWrapper anonymous={anonymous} href={FUNNEL}>
        <div className='mt-4 flex flex-col md:mt-7 md:flex-row'>
          <div
            className='our-team-image-container border-red flex w-full cursor-pointer flex-col items-center'
            onClick={() => !preview && setPreview(true)}>
            <Image
              alt=''
              id='our-team-image'
              className='static! mx-auto! my-0! w-auto! rounded-2xl object-contain'
              src={image}
              fill
              sizes='(max-width: 768px) 100vw, 50vw'
            />
            {preview && <FullPageImage image={image} onDismiss={() => setPreview(false)} />}
          </div>
        </div>
      </AnonymousWrapper>
      <div className='flex justify-center md:justify-end'>
        {type === 'default' && !isExternalJob && (
          <OffersDialogueButton
            jobPositionId={jobPositionId}
            status={status}
            jobTitle={title}
            employerName={employerName}
            label={t(`cta.${formalLanguage ? 'formal' : 'informal'}`)}
            className='mt-4 w-full md:mt-6 md:w-60 xl:px-4'
            openDialog={openDialog}
            slug={slug}
          />
        )}
      </div>
    </Section>
  );
};

export default OurTeam;
